import { Fragment } from 'react';

import { Container } from '@/shared/ui';

export default function ClinicsLoading() {
  // You can add any UI inside Loading, including a Skeleton.
  return (
    <Container maxWidth="5xl">
      <main>
        <section className="grid grid-flow-row gap-6 pt-4 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3">
          {Array(12)
            .fill(0)
            .map((_, _i) => (
              <Fragment key={_i}>
                <div className="flex h-80 w-full animate-pulse items-center justify-center rounded-md bg-gray-400"></div>
              </Fragment>
            ))}
        </section>
      </main>
    </Container>
  );
}
